import React from 'react';

import { Pane, Paragraph, Button } from 'evergreen-ui';

function DeletePublisher(props) {
  const handleDelete = (e) => {
    e.preventDefault();
    
    if (window.confirm("Are you sure you wish to delete your account? All data will be deleted.")) {
      props.handleDeletePublisher();
    }
  };

  return (
    <Pane display="flex" paddingY={8} alignItems="center">
      <Button intent="danger" marginRight={16} onClick={handleDelete}>
        Delete Account
      </Button>
      <Paragraph>
        Warning - this is not reversible. Make sure you have downloaded whatever
        you wish to keep first.
      </Paragraph>
    </Pane>
  );
}

export default DeletePublisher;
